// removed by extract-text-webpack-plugin
module.exports = {"event":"EventItem__event__F5uUH","inactive":"EventItem__inactive__Xfq9o","left":"EventItem__left__TWzOL","thumbnail":"EventItem__thumbnail__UvO5L","remove":"EventItem__remove__w8GJO"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard/events/EventItem/EventItem.scss
// module id = 318
// module chunks = 0